import router from '../router'
import cookie from '../config/cookie'
export default{
  // 储存user_id,token
  SAVEUSER (state, user) {
    state.token = user.token
    state.user_id = user.user_id
    cookie.set('ssotoken', user.token, 3)
    localStorage.setItem('user_id', user.user_id)
  },
  // 储存用户信息
  USERINFO (state, info) {
    state.userInfo = info
    localStorage.setItem('userInfo', JSON.stringify(info))
  },
  // 退出登录
  OUTLOGIN (state, value) {
    state.token = ''
    state.user_id = ''
    state.userInfo = {}
    cookie.del('ssotoken')
    localStorage.removeItem('user_id')
    localStorage.removeItem('userInfo')
  },
  // 登录失效
  LOSELOGIN (state, value) {
    state.token = ''
    state.user_id = ''
    state.userInfo = {}
    cookie.del('ssotoken')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('user_id')
    let returnUrl = value ? value.returnUrl : ''
    router.push({path: '/loginPage', query: {returnUrl: returnUrl}})
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js